<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import GroupInfoPanel from '../../../../../../groups/components/panels/GroupInfoPanel.vue'

import { Group } from '../../../../../../groups/models/group'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, group } = defineProps<{
  siteId: SiteID
  group: Group
}>()
</script>

<template>
  <GroupInfoPanel :site-id="siteId" :group="group" />
</template>
